import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Agenda } from './agenda.model';
import moment from 'moment';
import { Cabinet } from '@core/models/Cabinet';

export enum DISPLAY_AGENDA {
    GRAPHIC,
    LIST
}

export enum DOUBLE_VISUAL_AGENDA {
    CABINETS,
    PROFESSIONALS
}

export interface AgendaState extends EntityState<Agenda> {
    currentAgenda: Agenda;
    currentMoment: moment.Moment;
    movingAgenda: Agenda;
    openingTime: moment.Moment;
    closingTime: moment.Moment;
    protocolForce: boolean;
    loadedCount: number;
    gridLoaded: boolean;
    agendaDisplay: DISPLAY_AGENDA;
    doubleDisplay: DOUBLE_VISUAL_AGENDA;
    professionalCabinets: Cabinet[];
    hasDoubleVisual: boolean;
    isDragging?: boolean;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'agenda', idKey: 'id' })
export class AgendaStore extends EntityStore<AgendaState> {

    constructor() {
        super({
            currentMoment: moment(),
            loadedCount: 0,
            protocolForce: false,
            gridLoaded: false,
            agendaDisplay: DISPLAY_AGENDA.GRAPHIC,
            isDragging: false,
        });
    }

}
